import { CopyButton } from '../CopyButton';
import type { Btc15History } from '../../lib/btc15History';
import { exportHistory } from '../../lib/btc15History';
import styles from './Btc15HistoryTools.module.css';

export function Btc15HistoryTools({
  history,
  summaryText,
}: {
  history: Btc15History;
  summaryText: string;
}) {
  const handleExport = () => {
    const blob = new Blob([exportHistory(history)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `btc15-history-${new Date().toISOString().slice(0, 10)}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <section className={styles.card} aria-label="History tools">
      <CopyButton value={summaryText} label="Copy summary" className={styles.button} />
      <button type="button" className={styles.button} onClick={handleExport}>
        Export history
      </button>
    </section>
  );
}
